import React from 'react';
import { TabsContext } from '../tabsContext';

const Tabs: React.FC<{ children?: React.ReactNode; defaultId?: number }> = ({
  children,
  defaultId = 0
}): React.ReactElement => {
  const [activeTab, setActiveTab] = React.useState(defaultId);

  return (
    <TabsContext.Provider value={{ activeTab, selectTab: (id): void => setActiveTab(id) }}>
      {children}
    </TabsContext.Provider>
  );
};

export default Tabs;
